import { QuestRoutine, SkillKey } from "@joonapp/web-shared"

// Maps quest routine / skill enum values to their flat translation keys so the
// shared constants (which store English) can be localized at render time.
export const ROUTINE_LABEL_KEYS = {
  [QuestRoutine.MORNING]: "ROUTINE_MORNING",
  [QuestRoutine.AFTERNOON]: "ROUTINE_AFTERNOON",
  [QuestRoutine.NIGHT]: "ROUTINE_NIGHT",
  [QuestRoutine.ANYTIME]: "ROUTINE_ANYTIME",
} as const

export const SKILL_LABEL_KEYS = {
  [SkillKey.STAMINA]: "SKILL_STAMINA",
  [SkillKey.FOCUS]: "SKILL_FOCUS",
  [SkillKey.KINDNESS]: "SKILL_KINDNESS",
  [SkillKey.STRENGTH]: "SKILL_STRENGTH",
  [SkillKey.KNOWLEDGE]: "SKILL_KNOWLEDGE",
  [SkillKey.TEAMWORK]: "SKILL_TEAMWORK",
} as const
